(ns ycweb.app.minicart
  (:require
   [rum.core :as rum]
   [ycweb.app.common :as yac]
   [ycweb.app.website.cart.bridge :as bridge]
   [ycweb.app.website.cart.minicart :as minicart]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.state :as state]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.tracking :as tracking])
  (:require-macros
   [ycweb.util.core :as yuc]))

(yac/init-sentry)

(enable-console-print!)

(println "Loading Minicart.")
(println "Build Number:" (yuc/env :build-number "dev"))

;; Icon component to replicate the insert_icon Smarty function

(rum/defc loading < rum/static []
  [:div.minicart-loading
   [:span ""]])

(defmethod flow/render-screen :loading [app-atom _]
  (loading))

;; Cart item components

(defmethod comms/receive :chsk/state [app-atom [old n]]
  (when (and (:open? n) (not (get-in @app-atom [:comms :started])))
    (comms/send :web/start {})
    (swap! app-atom assoc-in [:comms :started] true)))

;; Forward declarations to avoid circular dependencies
;; `main` already loads the cart once the mount is hydrated, so this handler
;; only takes the state — otherwise every page fetches the cart twice.
(defmethod comms/receive :web/start [app-atom e]
  (swap! app-atom
    #(->
       %
       (assoc
         :opts (:opts e)
         :user (:user e)
         :stats (:stats e)
         :config (:config e)))))

(defn initial-state [started?]
  {:page {:screen :loading}
   :app {:started started? :version (yuc/env :build-number "dev") :app "minicart"}
   :device {:screen (state/screen-size) :id (comms/deviceid)}
   :cart-summary {}
   :popup-visible false})

(defmethod grid/action :state/reset [app-atom config _]
  (reset! app-atom
    (merge
      (initial-state true)
      config))
  (comms/send :web/start {}))

(defonce app-atom
  (atom (initial-state false)))

(defn ^:dev/after-load refresh []
  (when-let [mount-element (.getElementById js/document "minicart-react-mount")]
    (rum/mount
      (minicart/minicart app-atom true)
      mount-element)))

;; Store button state globally for restoration

;; Port of toggleButtonLoading JavaScript function

(defn main []
  (println "Initializing minicart component...")
  (tracking/install-inspector!)

  (if-let [pos (appcommon/entry-main "minicart-react-mount" app-atom refresh)]
    (do
      (rum/hydrate (minicart/minicart app-atom true) pos)
      (println "Minicart initialized.")
      (model/load-cart-data app-atom)
      (bridge/setup-button-hijacking app-atom))
    (js/console.warn "Minicart mount element not found — skipping initialization")))



